export const COOKIESPREFIX = 'TGATHER';

export const server_ip = ''

export const MAINCOLOR = '#938474'

export const SHARE_BASE_URL = 'https://www.tgather.cn'